export const spamTriggerWords: string[] = [
    '\'Hidden\' assets',
    '#1',
    '$$$',
    '100% Satisfied',
    '100% free',
    '4U',
    '50% off',
    'Accept credit cards',
    'Acceptance',
    'Access',
    'Accordingly',
    'Act Now',
    'Act now!',
    'Ad',
    'Additional income',
    'Addresses on CD',
    'Affordable',
    'All natural',
    'All new',
    'Amazing',
    'Amazing stuff',
    'Apply Online',
    'As seen on',
    'Auto email removal',
    'Avoid bankruptcy',
    'Bargain',
    'Be amazed',
    'Be your own boss',
    'Being a member',
    'Beneficiary',
    'Best price',
    'Beverage',
    'Big bucks',
    'Bill 1618',
    'Billing address',
    'Billion',
    'Billion dollars',
    'Bonus',
    'Brand new pager',
    'Bulk email',
    'Buy',
    'Buy direct',
    'Buying judgments',
    'Call',
    'Call free',
    'Call now',
    'Calling creditors',
    'Can\'t live without',
    'Cancel at any time',
    'Cannot be combined with any other offer',
    'Cards accepted',
    'Cash',
    'Cash bonus',
    'Cashcashcash',
    'Casino',
    'Celebrity',
    'Cell phone cancer scam',
    'Cents on the dollar',
    'Chance',
    'Cheap',
    'Check',
    'Check or money order',
    'Claims',
    'Claims not to be selling anything',
    'Claims to be in accordance with some spam law',
    'Claims to be legal',
    'Clearance',
    'Click',
    'Click below',
    'Click here',
    'Click to remove',
    'Collect',
    'Collect child support',
    'Compare',
    'Compare rates',
    'Compete for your business',
    'Confidentially on all orders',
    'Congratulations',
    'Consolidate debt and credit',
    'Consolidate your debt',
    'Copy DVDs',
    'Copy accurately',
    'Cost',
    'Costs',
    'Credit',
    'Credit bureaus',
    'Credit card offers',
    'Cures baldness',
    'Deal',
    'Dear',
    'Diagnostics',
    'Dig up dirt on friends',
    'Direct email',
    'Direct marketing',
    'Discount',
    'Do it today',
    'Don\'t delete',
    'Don\'t hesitate',
    'Don\'t hesitate!',
    'Dormant',
    'Double your',
    'Double your income',
    'Drastically reduced',
    'Earn',
    'Earn extra cash',
    'Earn per week',
    'Easy terms',
    'Eliminate bad credit',
    'Eliminate debt',
    'Email harvest',
    'Email marketing',
    'Expect to earn',
    'Explode your business',
    'Extra income',
    'F r e e',
    'Fantastic deal',
    'Fast Viagra delivery',
    'Fast cash',
    'Financial freedom',
    'Financially independent',
    'For Only',
    'For free',
    'For instant access',
    'For just',
    'For you',
    'Form',
    'Free',
    'Free DVD',
    'Free Instant',
    'Free consultation',
    'Free gift',
    'Free grant money',
    'Free hosting',
    'Free info',
    'Free installation',
    'Free investment',
    'Free leads',
    'Free membership',
    'Free money',
    'Free offer',
    'Free preview',
    'Free priority mail',
    'Free quote',
    'Free sample',
    'Free trial',
    'Free website',
    'Freedom',
    'Friend',
    'Full refund',
    'Get',
    'Get it now',
    'Get out of debt',
    'Get paid',
    'Get started now',
    'Gift certificate',
    'Give it away',
    'Giving away',
    'Great offer',
    'Guarantee',
    'Guaranteed',
    'Have you been turned down?',
    'Hello',
    'Here',
    'Hidden',
    'Hidden assets',
    'Hidden charges',
    'Home',
    'Home based',
    'Home employment',
    'Homebased business',
    'Human growth hormone',
    'If only it were that easy',
    'Important information regarding',
    'In accordance with laws',
    'Income',
    'Income from home',
    'Increase sales',
    'Increase traffic',
    'Increase your sales',
    'Incredible deal',
    'Info you requested',
    'Information you requested',
    'Insurance',
    'Internet market',
    'Internet marketing',
    'Investment',
    'Investment decision',
    'It\'s effective',
    'Join millions',
    'Join millions of Americans',
    'Laser printer',
    'Leave',
    'Legal',
    'Life',
    'Life Insurance',
    'Lifetime',
    'Limited time',
    'Limited time offer',
    'Limited time only',
    'Loans',
    'Long distance phone offer',
    'Lose',
    'Lose weight',
    'Lose weight spam',
    'Lower interest rate',
    'Lower interest rates',
    'Lower monthly payment',
    'Lower your mortgage rate',
    'Lowest Price',
    'Lowest insurance rates',
    'Luxury car',
    'MLM',
    'Mail in order form',
    'Maintained',
    'Make money',
    'Marketing',
    'Marketing solutions',
    'Mass email',
    'Medicine',
    'Medium',
    'Meet singles',
    'Member',
    'Member stuff',
    'Message contains',
    'Message contains disclaimer',
    'Million',
    'Million dollars',
    'Miracle',
    'Money',
    'Money back',
    'Money making',
    'Month trial offer',
    'More Internet Traffic',
    'Mortgage',
    'Mortgage rates',
    'Multi level marketing',
    'Name brand',
    'Never',
    'New customers only',
    'New domain extensions',
    'Nigerian',
    'No age restrictions',
    'No catch',
    'No claim forms',
    'No cost',
    'No credit check',
    'No disappointment',
    'No experience',
    'No fees',
    'No gimmick',
    'No hidden',
    'No inventory',
    'No investment',
    'No medical exams',
    'No middleman',
    'No obligation',
    'No purchase necessary',
    'No questions asked',
    'No selling',
    'No strings attached',
    'No-obligation',
    'Not intended',
    'Not spam',
    'Now',
    'Now only',
    'Obligation',
    'Off shore',
    'Offer',
    'Offer expires',
    'One hundred percent free',
    'One hundred percent guaranteed',
    'One time',
    'Online biz opportunity',
    'Online degree',
    'Online marketing',
    'Online pharmacy',
    'Only',
    'Open',
    'Opportunity',
    'Opt in',
    'Order',
    'Order now',
    'Order shipped by',
    'Order status',
    'Order today',
    'Orders shipped by',
    'Outstanding values',
    'Passwords',
    'Pennies a day',
    'Performance',
    'Phone',
    'Please read',
    'Potential earnings',
    'Pre-approved',
    'Price',
    'Prices',
    'Print form signature',
    'Print out and fax',
    'Priority mail',
    'Prize',
    'Prizes',
    'Problem',
    'Produced and sent out',
    'Profits',
    'Promise you',
    'Pure Profits',
    'Quote',
    'Quotes',
    'Real thing',
    'Refinance',
    'Refinance home',
    'Refinanced home',
    'Removal instructions',
    'Remove',
    'Removes wrinkles',
    'Reserves the right',
    'Reverses',
    'Reverses aging',
    'Risk free',
    'Rolex',
    'Round the world',
    'S 1618',
    'Safeguard notice',
    'Sale',
    'Sales',
    'Sample',
    'Satisfaction',
    'Satisfaction guaranteed',
    'Save',
    'Save big money',
    'Save up to',
    'Score with babes',
    'Search engine listing',
    'Search engines',
    'Section 301',
    'See for yourself',
    'Sent in compliance',
    'Serious cash',
    'Serious only',
    'Shopper',
    'Sign up free today',
    'Social security number',
    'Solution',
    'Special promotion',
    'Stainless steel',
    'Stock alert',
    'Stock disclaimer statement',
    'Stock pick',
    'Stop',
    'Stop snoring',
    'Strong buy',
    'Stuff on sale',
    'Subject to cash',
    'Subject to credit',
    'Success',
    'Supplies are limited',
    'Talks about hidden charges',
    'Talks about prizes',
    'Teen',
    'Tells you it\'s an ad',
    'Terms and conditions',
    'The best rates',
    'The following form',
    'They keep your money – no refund',
    'They\'re just giving it away',
    'This isn\'t a scam',
    'This isn\'t junk',
    'This isn\'t spam',
    'This won\'t last',
    'Thousands',
    'Time limited',
    'Trial',
    'US dollars',
    'Undisclosed recipient',
    'Unlimited',
    'Unsecured credit',
    'Unsecured credit/debt',
    'Unsecured debt',
    'Unsolicited',
    'Unsubscribe',
    'Urgent',
    'Vacation',
    'Vacation offers',
    'Valium',
    'Viagra',
    'Viagra and other drugs',
    'Vicodin',
    'Visit our website',
    'Wants credit card',
    'Warranty',
    'We hate spam',
    'We honor all',
    'Web traffic',
    'Weekend getaway',
    'Weight loss',
    'What are you waiting for?',
    'While supplies last',
    'While you sleep',
    'Who really wins?',
    'Why pay more?',
    'Wife',
    'Will not believe your eyes',
    'Win',
    'Winner',
    'Winning',
    'Won',
    'Work at home',
    'Work from home',
    'You are a winner!',
    'You have been selected',
    'You\'re a Winner!',
    'Your income',

    '100% garanti',
    '100% sur',
    'Abordable, coût',
    'Accès gratuit',
    'Acheter',
    'Amincissant',
    'Appel gratuit',
    'Assurance',
    'Augmentez',
    'Augmentez vos ventes',
    'Blackjack',
    'Bonne affaire',
    'Bravo',
    'Bénéfice',
    'Cadeau',
    'Calvitie',
    'Carte bancaire',
    'Carte de crédit',
    'Certifié',
    'Chaud',
    'Chiffre d\'affaire',
    'Cliquez ici',
    'Commande',
    'Commandez aujourd\'hui',
    'Comment maigrir',
    'Coupon',
    'Célibataires',
    'Deal incroyable',
    'Drogues',
    'Dés aujourd\'hui',
    'Dés maintenant',
    'Essai gratuit',
    'Essai gratuit',
    'Euros',
    'Exceptionnel',
    'Expire',
    'Facile',
    'Faillite',
    'Faites vite',
    'Félicitation',
    'Félicitations',
    'Gagner de l\'argent',
    'Garanti',
    'Gratuit',
    'Gratuitement',
    'Gratuitement aujourd\'hui',
    'Herbe',
    'Hypothéque',
    'Identité',
    'Inscription gratuite',
    'Inscrivez-vous dès maintenant',
    'Investissement',
    'Jeux d\'argent',
    'Kilos en trop',
    'Le taux d\'intérêt le plus bas',
    'Maigrir',
    'Meilleur prix',
    'Millions de dollars',
    'Minceur',
    'Mot de passe',
    'N\'hésitez pplus',
    'Offre',
    'Offre limitée',
    'Offre spéciale',
    'Ouvrez pour découvrir',
    'Par chèque/ virement bancaire',
    'Pas cher',
    'Pas d\'arnaque',
    'Pas de coûts cachés',
    'Pas de frais',
    'Pas un spam',
    'Paypal',
    'Perdre du poids',
    'Performances',
    'Plus de ventes',
    'Pour seulement',
    'Pour vous seulement',
    'Pourquoi payer plus ?',
    'Profitez maintenant',
    'Promotion spéciale',
    'Quantités limitées',
    'Rabais',
    'Rapide',
    'Rapidement',
    'Remboursement',
    'Remboursement intégral',
    'Remboursé',
    'Rencontres',
    'Revenu supplementaire',
    'Revenue',
    'Ronflements',
    'Récompense',
    'Réductions',
    'Salaire',
    'Sans effort',
    'Sans risque',
    'Satifaction garantie',
    'Sexe',
    'Soldes',
    'Sortir des dettes',
    'Streaming',
    'Taux d\'intérét',
    'Temps limité',
    'Télécharger des filmes',
    'Ultra efficace',
    'Ventes',
    'Vieillissement',
    'Votre cadeau',
    'Votre propre patron',
    'Votre traffic',
    'Vous avez gagner',
    'Vous avez été choisi',
    'Vous avez été sélectionné',
    'Vu à la TV',
    'ça fonctionne',
    'économiser',
    'érection'
];
